import { assessmentProgress } from '../../../utils/assessmentProgress';

export const assetName = row => row.safe_machine_name || row.machine_name || `설비·구역 #${row.machine_id}`;
export const isActiveAsset = row => Number(row.register_asset_status || 0) === 0 && Number(row.process_status || 0) === 0;
export const isActiveCause = row => isActiveAsset(row) && Number(row.register_cause_status || 0) === 0;
export const sameId = (a, b) => a != null && b != null && String(a) === String(b);
export const uniqueBy = (rows, key) => [...new Map(rows.filter(row => row[key] != null).map(row => [String(row[key]), row])).values()];

export function discoveryStatus(evaluation, available = true) {
  if (available === 'loading') return { label: '조회 중', color: 'default' };
  if (!available) return { label: '조회 불가', color: 'default' };
  return assessmentProgress(evaluation || {});
}

export function evaluationMap(rows = []) {
  const map = new Map();
  for (const row of rows) {
    const key = String(row.register_cause_id);
    if (!map.has(key) || Number(row.eval_id) > Number(map.get(key).eval_id)) map.set(key, row);
  }
  return map;
}

export function applicationCounts(assetIds, causeId, causes) {
  const ids = [...new Set(assetIds.map(String))];
  const skipped = causeId == null ? 0 : ids.filter(id => causes.some(row =>
    isActiveCause(row) && sameId(row.register_asset_id, id) && sameId(row.danger_cause_id, causeId))).length;
  return { added: ids.length - skipped, skipped };
}
